import React, { useContext, useState, useEffect } from "react";
import USER from "components/context/UserContext";
import axios from "axios";
import { server_api } from "config/config";
import styles from "styles/profilepage.module.css";

export default function RegisteredEvents() {
  const { user } = useContext(USER);
  const [registeredEvents, setRegisteredEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function getData() {
      const res = await axios({
        method: "GET",
        headers: { Authorization: user.token },
        baseURL: server_api,
        url: "events/registeredEvents",
      }).catch((err) => {
        // console.log(err);
      });

      // console.log("res", res);

      if (res?.data?.success) {
        setRegisteredEvents(res.data.events);
      }

      setLoading(false);
    }

    let source = null;
    if (user.token) {
      source = axios.CancelToken.source();
      getData();
    }

    return () => {
      /* clean-up */
      if (source) source.cancel();
    };
  }, [user]);

  return (
    // <div className={`${styles.profile_back} ${styles.registeredEvents}`}>
    <div className={styles.registeredEvents}>
      <h2>Registered Events</h2>
      {loading ? (
        <p className="text-center mt-4">Loading...</p>
      ) : (
        <div className={styles.profileRegEvents}>
          {registeredEvents?.length === 0 ? (
            <p className="text-center text-gray-400">
              No registered events yet.
            </p>
          ) : (
            <>
              {registeredEvents.map((event, _idx) => {
                return (
                  <div
                    key={_idx.toString()}
                    className={`${styles.chartEventProfile} inline`}
                  >
                    {event.title}
                  </div>
                );
              })}
            </>
          )}
        </div>
      )}
    </div>
  );
}
